// extracted by mini-css-extract-plugin
export default {"moduleTitle":"DigitalResourcesHomeList_moduleTitle__8mfBF"};